<template>
  <div class="mx-3 my-3 pb-4">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-12 md:col-span-2" style="cursor: pointer;">
        <div
          :class="currentRoute === 'ura-keys' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('ura-keys')"
        >
          <div class="flex">
            <div>URA Integration keys</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'ura-audit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('ura-audit')"
        >
          <div class="flex">
            <div>URA Audit logs</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'nira-credentials' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('nira-credentials')"
        >
          <div class="flex">
            <div>NIRA Credentials</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'nira-audit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('nira-audit')"
        >
          <div class="flex">
            <div>NIRA Audit logs</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'ursb-keys' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('ursb-keys')"
        >
          <div class="flex">
            <div>URSB Integration keys</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'ursb-audit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('ursb-audit')"
        >
          <div class="flex">
            <div>URSB Audit logs</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'infobip-credentials' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('infobip-credentials')"
        >
          <div class="flex">
            <div>Infobip Credentials</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-10">
        <UraIntegrationKeys v-if="currentRoute === 'ura-keys'" ref="uraKeysRef" />
        <UraKeysAudit v-if="currentRoute === 'ura-audit'" ref="uraAuditRef" />
        <NiraCredentials v-if="currentRoute === 'nira-credentials'" ref="niraCredentialsRef" />
        <NiraCredentialsAudit v-if="currentRoute === 'nira-audit'" ref="niraAuditRef" />
        <UrsbIntegrationKeys v-if="currentRoute === 'ursb-keys'" ref="ursbKeysRef" />
        <UrsbKeysAudit v-if="currentRoute === 'ursb-audit'" ref="ursbAuditRef" />
        <InfobipCredentials v-if="currentRoute === 'infobip-credentials'" ref="infobipCredentialsRef" />      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import UraIntegrationKeys from "./UraIntegrationKeys.vue";
import UraKeysAudit from "./UraKeysAudit.vue";
import NiraCredentials from "./NiraCredentials.vue";
import NiraCredentialsAudit from "./NiraCredentialsAudit.vue";
import UrsbIntegrationKeys from "./UrsbIntegrationKeys.vue";
import UrsbKeysAudit from "./UrsbKeysAudit.vue";
import InfobipCredentials from "./InfobipCredentials.vue";

type TabChild = { refresh?: () => void } | null;
type IntegrationRoute =
  | "ura-keys"
  | "ura-audit"
  | "nira-credentials"
  | "nira-audit"
  | "ursb-keys"
  | "ursb-audit"
  | "infobip-credentials";

const currentRoute = ref<IntegrationRoute>("ura-keys");
const uraKeysRef = ref<TabChild>(null);
const uraAuditRef = ref<TabChild>(null);
const niraCredentialsRef = ref<TabChild>(null);
const niraAuditRef = ref<TabChild>(null);
const ursbKeysRef = ref<TabChild>(null);
const ursbAuditRef = ref<TabChild>(null);
const infobipCredentialsRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "ura-keys") uraKeysRef.value?.refresh?.();
  else if (currentRoute.value === "ura-audit") uraAuditRef.value?.refresh?.();
  else if (currentRoute.value === "nira-credentials") niraCredentialsRef.value?.refresh?.();
  else if (currentRoute.value === "nira-audit") niraAuditRef.value?.refresh?.();
  else if (currentRoute.value === "ursb-keys") ursbKeysRef.value?.refresh?.();
  else if (currentRoute.value === "ursb-audit") ursbAuditRef.value?.refresh?.();
  else if (currentRoute.value === "infobip-credentials") infobipCredentialsRef.value?.refresh?.();
};

const select = (route: IntegrationRoute) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};

defineExpose({ refresh: refreshActiveTab });
</script>
